
import React from "react";
import { formatPrice, getProductCount } from "Utils/common";
import infoIcon from "Images/info.svg";
interface OrderSumCardProps {
    priceData: {
        total: string;
        originalTotal: string;
        savingTotal: string;
        [key: string]: string;
    };
    submitOrder?: () => void;
  }

  const OrderSumCard: React.FC<OrderSumCardProps> = ({ priceData }) => {
    const { originalTotal, savingTotal, total, products } = priceData;
    return (
      <div className="card sumCard">
        <div className="cardTitle">价格详情</div>
        <div className="block2 priceItem borderBottom">
          <label>产品价格({getProductCount(products)}件)</label>
          <span className="originTotal">{formatPrice(originalTotal)}</span>
        </div>
        <div className="priceItem borderBottom">
            <label>共节省</label>
          <span className="savingTotal">- {formatPrice(savingTotal)}</span>
        </div>
        <div className="priceItem lastItem">
          <label>总金额</label>
          <span className="total">{formatPrice(total)}</span>
        </div>
        <div className="block3 infoWrapper">
            <img alt="info" src={infoIcon}></img>
            <p className="info">由于四舍五入，网站计算价格会与发票价格有细微的差别，请以发票价格为准。</p>
        </div>
        <div className="gap12 clauseWrapper1" >
          提交本订单，代表您同意遵守本订单适用的促销活动细则。该细则应作为本订单条款和条件的组成部分。
        </div>
        <div className="termsWrapper1" >
          提交订单即表示您同意 <span style={{fontStyle: 'italic'}}>thermofisher.cn</span> 的销售条款与条件。 由 <a 
          className="textLink"
          style={{whiteSpace: 'nowrap'}}
          href={`https://www.thermofisher.cn/cn/zh/home/global/terms-and-conditions.html`}
          >此处</a> 查看条款与条件。
        </div>
        <p className="termsWrapper2">
          本网站销售的所有产品均不得用于人类或动物之临床诊断或治疗，仅可用于工业或者科研等非医疗目的。
        </p>
      </div>
    );
  };

  export default OrderSumCard;
  